<div *ngIf="height; then thenBlock; else elseBlock"></div>
<ng-template #thenBlock
  ><report-value
    [ngClass]="{ 'text-right': textRight, 'text-center': !textRight }"
    >{{ height | number: "1.1-1" }}</report-value
  ></ng-template
>
<ng-template #elseBlock><report-value>- -</report-value></ng-template>
